module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_primaerlogo_troms_og_finnmark_neg.07da32f4.png";